'use client';

import { ChevronLeft } from 'lucide-react';
import React from 'react';

interface StepLayoutProps {
  title: string;
  subtitle?: string;
  onBack?: () => void;
  children: React.ReactNode;
}

export const StepLayout: React.FC<StepLayoutProps> = ({ 
  title, 
  subtitle, 
  onBack, 
  children 
}) => {
  return (
    <div className="w-full max-w-4xl mx-auto p-6 md:p-8 animate-fade-in-up">
      <div className="mb-8 flex items-center gap-4">
        {onBack && (
          <button 
            onClick={onBack}
            className="p-2 rounded-full hover:bg-stone-800 text-stone-400 hover:text-white transition-colors"
          >
            <ChevronLeft size={24} />
          </button>
        )}
        <div>
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-white mb-2">{title}</h2>
          {subtitle && <p className="text-stone-400 text-lg">{subtitle}</p>}
        </div>
      </div>
      <div className="w-full">
        {children}
      </div>
    </div>
  );
};
